/**
 * Normalizes store-association API payloads (boolean, string, or numeric).
 */
export function isWarehouseAssociatedResponse(value: unknown): boolean {
  return value === true || value === 'true' || value === 1;
}
